import { useContext } from 'react';
import { StyledClassicModalFeedback } from '../../../../ClassicGameActivity.styled';
import { GameStageContext } from '@/shared/GameComponents/GameStageContext/GameStageContext';
import { GameLoopContext } from '@/shared/GameComponents/GameLoopContext/GameLoopContext';

export default function FinalScreen() {
  const gameStage = useContext(GameStageContext);
  const game = useContext(GameLoopContext);

  const allCorrect = game.state.answersLog.every((answer) => answer.correct);

  return (
    <StyledClassicModalFeedback stage={gameStage.state}>
      <div className="finished-text">
        <p className="title">You're done</p>
        <>
          {allCorrect ? (
            <>
              <p>You got everything right</p>
              <p>
                in{' '}
                <span className="time">
                  {game.state.elapsedTime.minutes != '0' && (
                    <>{game.state.elapsedTime.minutes} minutes and</>
                  )}{' '}
                  {game.state.elapsedTime.seconds} seconds!
                </span>{' '}
              </p>
            </>
          ) : (
            <>
              <p>
                in{' '}
                <span className="time">
                  {game.state.elapsedTime.minutes != '0' && (
                    <>{game.state.elapsedTime.minutes} minutes and</>
                  )}{' '}
                  {game.state.elapsedTime.seconds} seconds.
                </span>{' '}
              </p>
              <p>But not everything is correct.</p>
              <p>
                Take a minute to review any <br /> concepts you might have
                missed.
              </p>
            </>
          )}
        </>
      </div>
    </StyledClassicModalFeedback>
  );
}
